var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIusPrecAsset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 403.95 333.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        filter: url(#drop-shadow-2);\n      }\n\n      .cls-2 {\n        stroke: #dcedf4;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        stroke-width: .67px;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2, .cls-13, .cls-15, .cls-16, .cls-17, .cls-19 {\n        fill: none;\n      }\n\n      .cls-2, .cls-13, .cls-15, .cls-17, .cls-19 {\n        stroke-linecap: round;\n      }\n\n      .cls-20 {\n        fill: url(#Cielo_5);\n      }\n\n      .cls-20, .cls-21, .cls-22 {\n        opacity: .59;\n      }\n\n      .cls-23 {\n        fill: #009ff7;\n      }\n\n      .cls-3 {\n        fill: url(#Degradado_sin_nombre_6);\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        stroke: #293852;\n      }\n\n      .cls-4 {\n        fill: url(#Degradado_sin_nombre_2);\n      }\n\n      .cls-5 {\n        fill: url(#Degradado_sin_nombre_13);\n      }\n\n      .cls-6 {\n        fill: url(#Degradado_sin_nombre_12);\n      }\n\n      .cls-24 {\n        fill: #004ecc;\n      }\n\n      .cls-25 {\n        fill: #82acc4;\n      }\n\n      .cls-7 {\n        fill: url(#Degradado_sin_nombre_6-5);\n      }\n\n      .cls-8 {\n        fill: url(#Degradado_sin_nombre_6-6);\n      }\n\n      .cls-9 {\n        fill: url(#Degradado_sin_nombre_6-7);\n      }\n\n      .cls-10 {\n        fill: url(#Degradado_sin_nombre_6-4);\n      }\n\n      .cls-11 {\n        fill: url(#Degradado_sin_nombre_6-3);\n      }\n\n      .cls-12 {\n        fill: url(#Degradado_sin_nombre_6-2);\n      }\n\n      .cls-13 {\n        stroke: #bee2f4;\n      }\n\n      .cls-13, .cls-17 {\n        stroke-width: 2.01px;\n      }\n\n      .cls-14 {\n        stroke: #000;\n        stroke-width: 1.39px;\n      }\n\n      .cls-21 {\n        fill: #004976;\n      }\n\n      .cls-26 {\n        fill: #fff;\n      }\n\n      .cls-27 {\n        fill: #678b9b;\n      }\n\n      .cls-28 {\n        fill: #223b72;\n        opacity: .66;\n      }\n\n      .cls-29 {\n        fill: url(#Degradado_sin_nombre_4);\n      }\n\n      .cls-15, .cls-16 {\n        stroke: #d6e9f2;\n        stroke-width: .74px;\n      }\n\n      .cls-22 {\n        fill: #034d77;\n      }\n\n      .cls-17 {\n        stroke: #fff;\n      }\n\n      .cls-18 {\n        fill: url(#Degradado_sin_nombre_9);\n        stroke: url(#Degradado_sin_nombre_11);\n        stroke-width: .71px;\n      }\n\n      .cls-19 {\n        filter: url(#drop-shadow-1);\n        stroke: #d3e9ef;\n        stroke-width: 1.34px;\n      }\n\n      .cls-30 {\n        fill: #e3f4ff;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_13",
    "data-name": "Degradado sin nombre 13",
    x1: 310.81,
    y1: 290.27,
    x2: 310.81,
    y2: 122.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b99a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#8194a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#68899d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#3f7793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#136489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004570"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_12",
    "data-name": "Degradado sin nombre 12",
    x1: 310.7,
    y1: 292.14,
    x2: 310.7,
    y2: 127.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7aa7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#bfdff5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#edf6fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    x: 281.25,
    y: 151.49,
    width: 59.69,
    height: 8.28,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.37,
    dy: 0.37
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 0
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#033266",
    floodOpacity: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6",
    "data-name": "Degradado sin nombre 6",
    x1: 237.99,
    y1: 155.17,
    x2: 237.99,
    y2: 276.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cce0f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d5e5f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#eef5fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6-2",
    "data-name": "Degradado sin nombre 6",
    x1: 385.58,
    y1: 155.17,
    x2: 385.58,
    y2: 276.15,
    xlinkHref: "#Degradado_sin_nombre_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9",
    "data-name": "Degradado sin nombre 9",
    x1: 310.76,
    y1: 133.59,
    x2: 310.76,
    y2: 292.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fefeff",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fdfeff",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fafcff",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#f6faff",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#f2f8ff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ecf5ff",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#e5f2ff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#def",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#d5eaff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#d5eaff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#def",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#e5f2ff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#edf6ff",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#f3f9ff",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#f8fbff",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#fcfdff",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fefeff",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_11",
    "data-name": "Degradado sin nombre 11",
    x1: 244.38,
    y1: 212.95,
    x2: 377.13,
    y2: 212.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004976",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#97bbd7",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#8db4d1",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#74a1c1",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#4b82a6",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#135782",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004976",
    stopOpacity: 0.59
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-2",
    x: 251.9,
    y: 139.37,
    width: 123.24,
    height: 146.86,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.37,
    dy: 0.37
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 0
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#033266",
    floodOpacity: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6-3",
    "data-name": "Degradado sin nombre 6",
    x1: 380.08,
    y1: 75,
    x2: 380.08,
    y2: 56.82,
    xlinkHref: "#Degradado_sin_nombre_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6-4",
    "data-name": "Degradado sin nombre 6",
    x1: 370.41,
    y1: 87.44,
    x2: 370.41,
    y2: 45.58,
    xlinkHref: "#Degradado_sin_nombre_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6-5",
    "data-name": "Degradado sin nombre 6",
    x1: 247.21,
    y1: 75.29,
    x2: 247.21,
    y2: 55.97,
    xlinkHref: "#Degradado_sin_nombre_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6-6",
    "data-name": "Degradado sin nombre 6",
    x1: 255.91,
    y1: 83.55,
    x2: 255.91,
    y2: 46.62,
    xlinkHref: "#Degradado_sin_nombre_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6-7",
    "data-name": "Degradado sin nombre 6",
    x1: 312.67,
    y1: 143.04,
    x2: 312.67,
    y2: 11.71,
    xlinkHref: "#Degradado_sin_nombre_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4",
    "data-name": "Degradado sin nombre 4",
    x1: 314.02,
    y1: 143.04,
    x2: 314.02,
    y2: 22.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9fcced"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#a8d0ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#c1def3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#eaf4fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_2",
    "data-name": "Degradado sin nombre 2",
    cx: 310.94,
    cy: 66.03,
    fx: 310.94,
    fy: 66.03,
    r: 55.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e528d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#293852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#182942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e2038"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Cielo_5",
    "data-name": "Cielo 5",
    x1: 256.98,
    y1: 317.48,
    x2: 360.68,
    y2: 317.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d5eaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#cbe7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#b2e0fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#88d4fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#4fc4fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#23b8fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#009dfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0098fc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M272.08,128.11s-13.02,8.66-16.84,10.39c-3.82,1.74-8.27,4.66.46,20.88,8.73,16.21-1.64,24.9-1.64,24.9l9.28,74.12s7.64,31.27,40.39,31.85c32.75.58,48.58-9.84,51.86-20.27,3.28-10.42,8.73-76.44,8.73-76.44,0,0-3.28-16.79,1.09-22.58,4.37-5.79-.55-20.27-.55-20.27l6.08-7.59-21.97-13.31s-41.42-15.58-76.9-1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M376.63,145.39c-2.76-2.76-6.76-6.82-11.72-2.35l-14.75-8.2s-43.07-15.28-79.97-1.65c0,0-2.24.92-5.11,2.1-.02-.03-.05-.07-.05-.07-2.61-3.93-5.34-1.75-5.34-1.75,0,0-8.51,2.84-14.19,5.68-5.68,2.84,5.61,26.77,5.61,26.77l2.53,38.74,2.91,44.55c.19,2.94,5.38,42.46,46.57,42.93,34.06.39,50.52-9.65,53.93-19.87.82-2.47,7.66-20.83,9.93-34.91,2.84-17.6,5.11-76.63,5.11-76.63,0,0,7.95-11.92,4.54-15.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M282.29,152.77s34.05,13.82,57.98-.6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 310.79,
    cy: 140.87,
    rx: 29.19,
    ry: 9.11
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M251.48,160.72s-3.97-12.49-7.38,0c0,0,0,6.81-.57,14.19-.57,7.38-21,55.63-22.71,66.98-1.7,11.35-1.7,28.95,7.38,33.49,9.08,4.54,22.14-12.49,22.14-12.49,0,0,4.54-5.68,4.54-14.19,0-8.51-5.68-48.82-.57-64.14,5.11-15.33-2.84-23.84-2.84-23.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M250.71,167.51s-2.13-10.96-5.15-.31c0,0-.35,5.88-1.13,12.25-.77,6.35-17.54,47.22-19.3,56.95-1.78,9.75-2.69,24.95,3.42,29.26,6.11,4.32,16.1-9.87,16.1-9.87,0,0,3.46-4.72,3.9-12.09.44-7.37-1.45-42.45,2.91-55.46-.38-12.31-.75-20.74-.75-20.74Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M372.09,160.72s3.97-12.49,7.38,0c0,0,0,6.81.57,14.19.57,7.38,21,55.63,22.71,66.98,1.7,11.35,1.7,28.95-7.38,33.49s-22.14-12.49-22.14-12.49c0,0-4.54-5.68-4.54-14.19s5.68-48.82.57-64.14c-5.11-15.33,2.84-23.84,2.84-23.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M374.01,162.31s3.45-11.87,4.21,6.13c0,0,0,6.13,2.41,12.58,2.28,6.1,17.05,48.15,18.69,58.04,1.64,9.89,2.34,25.34-3.92,29.62-6.26,4.28-16.18-10.26-16.18-10.26,0,0-3.43-4.84-3.76-12.32-.33-7.48,2.13-43.02-2.09-56.28-1.28-14.88.64-27.51.64-27.51Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M376.14,146.02c-3.76-3.53-8.55-9.08-15.57,4.55-32.21,21.44-32.19,21.7-38.6,28.01-7.27,7.17-13.78,24.25-13.78,24.25,0,0,3.38,9.95-1.33,1.81-18.46-31.92-41.78-68.12-41.78-68.12-2.57-4.51-4.91-2.47-4.91-2.47,0,0-8.9,2.02-14.21,5.72-4.38,3.05,4.27,21.17,5.73,25.41,7.28,100.64,6.92,88.22,7.91,91.2,6.63,19.89,23.23,24.76,32.41,28.73,36.34,15.71,53.94,1.35,57.7-2.21,18.17-17.19,21.56-122.45,21.56-122.45,0,0,7.72-11.75,4.86-14.43Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M372.09,147.77c-5.13,3.35-14.93,12.63-21.44,27.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M354,267.02s8.78-31.04,11.46-71.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M370.79,145.1c-19.33,15.49-40.75,22.15-54.15,43.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M374.77,148.91c-8.42,8.04-7.73,36.25-9.42,41.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M260.91,139.74s8.39,3.01,26.8,40.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M252.64,144.32s10.24,20.4,9.59,52.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M255.55,142.42s20.75,19.91,22.55,58.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M258.79,213.66c.1,36.08,6.15,62.38,41.5,69.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M306.59,198.6c-7.24-1.76-16.53,33.88-33.23,37.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M312.15,198.6c7.24-1.76,20.95,30.61,37.65,33.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M302.21,204.33c-5.52,31.67-20.26,33.51-15.84,57.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M306.51,198.46c2.21,41.23,1.39,72.33,2.21,87.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M303.85,201.75c-.16,39.41-8.51,41.99-2.86,68.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M306.34,198.46c6.55,30.18,11.7,72.9,10.72,79.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M306.28,198.52c21.34,44.48,35.09,49.02,35.58,67.68,0,0-.57,11.79-3.52,15.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M314.61,201.27c2.38,18.54,36.17,38.91,36.33,47.42"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M339.46,180.66c0,.35.01.68.03.89h-.27c-.4-1.98-1.01-2.62-2.11-2.62h-.26v6.69c0,.96.21,1.09,1.25,1.11v.23c-.5-.02-1.37-.03-2.23-.03s-1.68.02-2.14.03v-.23c1.04-.01,1.25-.15,1.25-1.11v-6.69h-.26c-1.11,0-1.71.64-2.11,2.62h-.27c.02-.22.03-.54.03-.89,0-.39-.02-1.2-.08-1.99,1.06.03,2.58.03,3.62.03s2.55,0,3.61-.03c-.06.8-.09,1.6-.09,1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M346.43,180.45c0,.35.01.68.03.89h-.27c-.31-1.82-.92-2.41-2.02-2.41h-.39c-.68,0-.81.1-.81.84v2.95h.41c.94,0,1.27-.92,1.39-1.55h.27c-.03.52-.05.86-.05,1.14,0,.2,0,.37,0,.53,0,.39.01.77.07,1.67h-.27c-.13-.82-.49-1.55-1.43-1.55h-.41v2.7c0,.92.21,1.04,1.25,1.05v.26c-.48-.02-1.3-.03-2.14-.03-.68,0-1.35.02-1.86.03v-.23c.74-.03.88-.15.88-1.01v-5.82c0-.85-.14-.97-.88-1.01v-.23c1.28.03,3.04.03,3.82.03.72,0,1.73,0,2.45-.03-.06.71-.08,1.43-.08,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M350.75,178.91c-.75.03-.88.15-.88,1.01v4.91c0,.86-.02,1.81-.2,2.45-.31,1.08-1.38,1.91-2.97,1.91-.42,0-.88-.07-1.18-.22-.41-.21-.58-.49-.58-.85,0-.48.38-.79.94-.79s.89.27.89.77c0,.34-.2.64-.6.77.1.07.3.09.42.09.59,0,1.01-.36,1.19-.84.21-.61.22-1.21.22-2.83v-5.36c0-.85-.14-.97-.88-1.01v-.23c.38.02,1.06.03,1.78.03.68,0,1.41-.01,1.84-.03v.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M358.05,185.99c.22.56.52.74.74.75v.23c-.46-.02-1.14-.03-1.78-.03-.73,0-1.4.01-1.79.03v-.23c.56-.02.82-.11.82-.43,0-.14-.05-.32-.14-.56l-.7-1.92h-2.55l-.31.81c-.22.57-.32.99-.32,1.3,0,.62.4.78,1.04.8v.23c-.53-.02-.97-.03-1.46-.03-.34,0-.66.01-.9.03v-.23c.34-.06.69-.37,1.02-1.23l2.67-6.86c.13.01.26.02.41.02s.28,0,.41-.02l2.85,7.34ZM353.96,180.44l-1.21,3.16h2.38l-1.16-3.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M339.08,180.28c0,.35.01.68.03.89h-.27c-.4-1.98-1.01-2.62-2.11-2.62h-.26v6.69c0,.96.21,1.09,1.25,1.11v.23c-.5-.02-1.37-.03-2.23-.03s-1.68.02-2.14.03v-.23c1.04-.01,1.25-.15,1.25-1.11v-6.69h-.26c-1.11,0-1.71.64-2.11,2.62h-.27c.02-.22.03-.54.03-.89,0-.39-.02-1.2-.08-1.99,1.06.03,2.58.03,3.62.03s2.55,0,3.61-.03c-.06.8-.09,1.6-.09,1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M346.05,180.07c0,.35.01.68.03.89h-.27c-.31-1.82-.92-2.41-2.02-2.41h-.39c-.68,0-.81.1-.81.84v2.95h.41c.94,0,1.27-.92,1.39-1.55h.27c-.03.52-.05.86-.05,1.14,0,.2,0,.37,0,.53,0,.39.01.77.07,1.67h-.27c-.13-.82-.49-1.55-1.43-1.55h-.41v2.7c0,.92.21,1.04,1.25,1.05v.26c-.48-.02-1.3-.03-2.14-.03-.68,0-1.35.02-1.86.03v-.23c.74-.03.88-.15.88-1.01v-5.82c0-.85-.14-.97-.88-1.01v-.23c1.28.03,3.04.03,3.82.03.72,0,1.73,0,2.45-.03-.06.71-.08,1.43-.08,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M350.37,178.52c-.75.03-.88.15-.88,1.01v4.91c0,.86-.02,1.81-.2,2.45-.31,1.08-1.38,1.91-2.97,1.91-.42,0-.88-.07-1.18-.22-.41-.21-.58-.49-.58-.85,0-.48.38-.79.94-.79s.89.27.89.77c0,.34-.2.64-.6.77.1.07.3.09.42.09.59,0,1.01-.36,1.19-.84.21-.61.22-1.21.22-2.83v-5.36c0-.85-.14-.97-.88-1.01v-.23c.38.02,1.06.03,1.78.03.68,0,1.41-.01,1.84-.03v.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M357.67,185.61c.22.56.52.74.74.75v.23c-.46-.02-1.14-.03-1.78-.03-.73,0-1.4.01-1.79.03v-.23c.56-.02.82-.11.82-.43,0-.14-.05-.32-.14-.56l-.7-1.92h-2.55l-.31.81c-.22.57-.32.99-.32,1.3,0,.62.4.78,1.04.8v.23c-.53-.02-.97-.03-1.46-.03-.34,0-.66.01-.9.03v-.23c.34-.06.69-.37,1.02-1.23l2.67-6.86c.13.01.26.02.41.02s.28,0,.41-.02l2.85,7.34ZM353.57,180.06l-1.21,3.16h2.38l-1.16-3.16Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M376.63,56.84h5.68s1.14-.57,1.14,5.11,1.14,12.49-5.68,13.06l-1.14-18.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M363.29,45.77h8.51s7.38-2.27,7.95,9.08,0,21.57,0,21.57c0,0,1.7,7.38-8.51,10.79-10.22,3.41-13.06-31.22-7.95-41.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M250.9,55.99h-4.54s-2.84-.57-2.84,4.54v8.51s.57,6.24,3.41,6.24h2.84l1.14-19.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M264.24,47.19l-7.95-.57s-6.24,0-7.95,9.65c-1.7,9.65,0,21.57,0,21.57,0,0,0,6.24,5.68,5.68,5.68-.57,9.08-.57,9.08-.57l1.14-35.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M264.24,34.7s4.54-23.27,21.29-22.99,56.77,1.14,56.77,1.14c0,0,11.64-5.96,18.45,11.07,6.81,17.03,10.22,46.55,7.95,70.96-2.27,24.41-22.71,52.22-56.77,47.68-34.06-4.54-53.36-16.46-55.63-47.12-2.27-30.65,7.95-60.74,7.95-60.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M361.41,49.96s23.69,88.44-45.56,88.44-53.6-72.36-50.92-96.48c-2.68,8.04-7.44,34.93-5.36,53.6,3.4,30.55,18.29,42.49,52.35,47.03,34.06,4.54,54.49-23.27,56.76-47.68,2.27-24.41-9.28-77.82-9.95-71.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M341.69,12.74s41.03,119-28.22,119-42.16-68.48-28.54-120.12c0,0,28.94-26.1,56.76,1.13Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M295.78,108.67c2.28,4.73,7.48,6.72,15.61,6.72s13.22-1.99,15.64-6.72l1.63.43c-2.49,6.68-7.91,9.68-17.23,9.68s-14.81-3-17.27-9.68l1.63-.43Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M340.55,62.52c0,9.88-2.34,14.16-9.13,14.16s-9.09-4.29-9.09-14.16,2.3-14.16,9.09-14.16,9.13,4.29,9.13,14.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M343.58,47.52c.68,0,.91.28.91.95v2.42c-.04,1.9-.44,3.89-1.11,5.52l-1.15-.36c.2-1.55.28-2.58.28-4.44-.44,0-.72-.32-.68-.83v-2.3c.04-.67.32-.95.99-.95h.75ZM349.1,47.52c.68,0,.91.28.91.95v2.42c-.04,1.9-.44,3.89-1.11,5.52l-1.15-.36c.2-1.55.28-2.58.28-4.44-.44,0-.71-.32-.68-.83v-2.3c.04-.67.32-.95.99-.95h.75Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M294.8,48.35c6.78,0,9.09,4.29,9.09,14.16s-2.3,14.16-9.09,14.16c-6.78,0-9.13-4.29-9.13-14.16,0-9.88,2.34-14.16,9.13-14.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M283.4,47.52c.68,0,.95.28.99.95v2.3c.04.52-.24.83-.68.83,0,1.86.08,2.9.28,4.44l-1.15.36c-.68-1.63-1.07-3.61-1.11-5.52v-2.42c0-.67.24-.95.91-.95h.75ZM277.89,47.52c.68,0,.95.28.99.95v2.3c.04.52-.24.83-.68.83,0,1.86.08,2.9.28,4.44l-1.15.36c-.67-1.63-1.07-3.61-1.11-5.52v-2.42c0-.67.24-.95.91-.95h.75Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M371.71,47.95s3.01,4.94,3.01,14.68-1.5,19.13-1.5,19.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M256,48.53s-3.87,7.15-4,14.18,1.37,15.63,1.37,15.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.64,59.34s-.79,4.4-.27,9.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M381.48,59.42s1.67,5.3.03,10.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348.01,25.84c14.74,49.58,5.36,77.72,5.36,77.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.61,98.2c-5.36-18.76,10.72-72.36,10.72-72.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M316.59,5.9s21.84-1.51,23.72,22.22"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M332.58,215.07v-18.81c0-2.63-1.42-5.08-3.7-6.37l-16.27-9.43c-2.28-1.33-5.08-1.33-7.36,0l-16.32,9.43c-2.28,1.33-3.7,3.75-3.7,6.37v18.81c0,2.63,1.42,5.08,3.7,6.37l16.32,9.43c2.28,1.33,5.08,1.33,7.36,0l16.32-9.43c2.28-1.33,3.7-3.75,3.7-6.37h-.04Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M281.83,191.61v24.11c0,1.38.73,2.65,1.93,3.34l20.88,12.05c1.19.69,2.66.69,3.85,0l20.88-12.05c1.19-.69,1.93-1.96,1.93-3.34v-24.11c0-1.38-.73-2.65-1.93-3.34l-20.88-12.05c-1.19-.69-2.66-.69-3.85,0l-20.88,12.05c-1.19.69-1.93,1.96-1.93,3.34Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M315.16,207.37c-.84-.7,0-1.39-.09-2.07-.04-.25.13-.48-.29-.54-.21-.03-.25-.35-.3-.56-.32-1.5-1.22-2.77-1.69-4.21-.09-.27-.28-.49-.57-.59-.72-.26-.96-.78-.72-1.53.05-.15.1-.31.12-.46.04-.48-.11-.91-.55-1.13-.4-.2-.84-.09-1.11.22-.3.35-.65.77-.28,1.3.24.33.05.75.27,1.1.1.17-.14.26-.28.32-.16.07-.28-.01-.32-.17-.03-.12-.01-.25-.06-.36-.11-.28.46-.73-.13-.85-.32-.06-.53-.4-.89-.3-.07.02-.22-.02-.22-.02.05-.58-.73-.9-.47-1.53.09-.22.07-.43-.02-.65-.15-.37-.24-.76-.08-1.12.17-.41-.12-.73-.14-1.09,0-.07-.07-.15-.17-.14-.12.01-.15.09-.17.21-.22,1.33-.23,2.67-.25,4,0,.33-.03.48-.4.45-.31-.03-.49.34-.82.32-.06,0-.12,1.58-.06,1.64.35.32.3.75.25,1.15-.02.18-.3.15-.48.11-.18-.04-.23-.15-.14-.32.05-.09.09-.18.01-.31-.05.07-.13.13-.13.19-.01.27-.5.34-.32.64.21.34.61.38.97.4.24.01.49-.04.69-.18.14-.1.24-.15.04-.39-.55-.64-.65-1.47-.58-2.28.03-.42.51-.46.85-.56.3-.1.42.13.53.36.45.95,1.2,1.7,1.73,2.62.65,1.15.59,2.2.23,3.35-.26.82-.41,1.66-.3,2.51.13.99-.27,1.89-.39,2.84-.07.6.28,1.34.85,1.5.21.06.4.09.4.35,0,.37-.3.18-.45.2-.64.08-1.05.43-1.19,1.11-.17.85-.31,1.71-.45,2.57-.19,1.17-.59,1.51-1.78,1.51-1.15,0-2.31,0-3.46,0-1.24,0-1.79-.68-1.51-1.88,1.62-6.86,3.25-13.72,4.87-20.59.22-.94.45-1.89.67-2.83.24-1.03.59-1.32,1.63-1.32,1.96,0,3.93,0,5.89,0,.89,0,1.28.32,1.49,1.19,1.88,7.86,3.77,15.72,5.65,23.58.28,1.16-.28,1.85-1.47,1.85-1.22,0-2.43,0-3.65,0-.92,0-1.37-.41-1.52-1.31-.15-.92-.32-1.83-.47-2.75-.07-.41-.24-.75-.61-.93-.32-.15-.31-.31-.2-.6.45-1.21.89-2.43,1.29-3.65.13-.4.28-.59.76-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M297.25,203.74c0,3.46,0,6.93,0,10.39,0,.54-.07,1.06-.28,1.54-.34.79-.89,1.3-1.82,1.22-.24-.02-.49,0-.73,0-1.5,0-2.24-.68-2.39-2.2-.02-.18-.01-.36-.01-.55,0-6.95,0-13.9,0-20.84,0-.47.05-.93.21-1.37.37-1.02.87-1.37,1.94-1.37.2,0,.41,0,.61,0,1.63,0,2.42.77,2.46,2.44.02.83,0,1.66,0,2.49,0,2.76,0,5.51,0,8.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M312.4,211.29c-.05-.43-.17-.86.29-1.16.2-.13.19-.45.09-.62-.51-.93-.35-1.9-.16-2.84.27-1.31.16-2.51-.57-3.66-.35-.56-.22-1.14.28-1.92.16.33.33.61.45.92.33.87.69,1.72,1.12,2.55.28.53.12,1.15.32,1.71.15.4-.38.09-.52.3.12.14.32.27.23.53-.46,1.41-.93,2.82-1.53,4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M307.98,198.05c.39-.1.66.12.94.24.3.13.25.39.12.6-.17.28-.35.04-.48-.07-.24-.2-.46-.44-.59-.78Z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 308.83,
    cy: 317.48,
    rx: 51.85,
    ry: 16.18
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 308.83,
    cy: 317.48,
    rx: 30.35,
    ry: 9.47
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.35,190.03c0,3.55.93,5.24,3.82,5.24v1.25c-1.25-.12-2.5-.18-3.7-.18-3.32,0-6.23.23-8.71.82v-5.39c-1.95,3.99-5.5,5.56-9.61,5.56-3.29,0-5.27-.96-6.52-2.36-1.31-1.49-1.81-3.79-1.81-7.72v-15.12c0-3.58-.93-5.27-3.82-5.27v-1.25c1.25.12,2.51.2,3.7.2,3.32,0,6.2-.26,8.71-.85v24.73c0,2.97.58,5.01,3.55,5.01,3.18,0,5.8-2.97,5.8-6.9v-15.67c0-3.58-.93-5.27-3.82-5.27v-1.25c1.25.12,2.5.2,3.7.2,3.32,0,6.23-.26,8.71-.85v25.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.67,166.64c.41.26.76.41,1.08.41.7,0,1.19-.7,1.4-2.18h1.28c-.2,2.27-.26,5.18-.26,10.49h-1.25c-.61-4.4-2.56-9.23-7.66-9.23-2.3,0-4.05,1.4-4.05,3.85,0,3.58,3.67,5.56,7.34,8.3,3.99,2.94,7.14,5.5,7.14,10.22,0,5.45-5.16,8.85-11.3,8.85-2.39,0-4.25-.52-5.59-1.25-1.08-.55-1.92-.99-2.77-1.25-.09-.03-.18-.06-.26-.06-.67,0-1.17.84-1.46,2.13h-1.25c.18-2.56.23-5.88.23-11.91h1.28c.73,6.47,3.03,10.98,8.04,10.98,2.07,0,4.19-1.19,4.19-4.25,0-3.5-2.59-5.45-6.03-8.13-3.9-3.06-7.49-5.77-7.49-10.57,0-5.3,4.84-8.21,10.25-8.21,3.35,0,5.97,1.08,7.14,1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.45,165.68v1.19h-7.05v24.06c0,2.45.87,3.32,2.62,3.32,1.46,0,2.91-.93,4.08-3.58l.99.55c-1.31,3.55-3.76,6.12-8.16,6.12-2.68,0-4.63-.67-5.97-2.01-1.72-1.75-2.16-4.17-2.16-8.33v-20.13h-5.01v-1.19h5.01v-7.89c3.35-.03,6.12-.58,8.59-1.92v9.82h7.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.7,190.96c0,3.32,1.02,4.28,3.82,4.28v1.25c-1.51-.06-4.86-.23-7.98-.23s-6.67.17-8.24.23v-1.25c2.77,0,3.82-.96,3.82-4.28v-18.82c0-3.58-.93-5.27-3.82-5.27v-1.25c1.25.12,2.51.2,3.7.2,3.32,0,6.2-.26,8.71-.85v25.98ZM120.43,154.84c0,2.88-2.13,4.63-5.42,4.63s-5.45-1.75-5.45-4.63,2.1-4.6,5.45-4.6,5.42,1.75,5.42,4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.25,165.68v1.19h-7.05v24.06c0,2.45.87,3.32,2.62,3.32,1.46,0,2.91-.93,4.08-3.58l.99.55c-1.31,3.55-3.76,6.12-8.16,6.12-2.68,0-4.63-.67-5.97-2.01-1.72-1.75-2.16-4.17-2.16-8.33v-20.13h-5.01v-1.19h5.01v-7.89c3.35-.03,6.12-.58,8.59-1.92v9.82h7.05Z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 9.94,
    cy: 155.44,
    r: 4.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1.4,168.32c-.14-.3-.29-.65-.47-1.04.27-.12.49-.23.73-.32,3.22-1.12,6.43-2.26,9.67-3.34.7-.23,1.49-.24,2.4-.37,0,.53,0,.88,0,1.22,0,7.99-.02,15.98.02,23.96,0,1.13.18,2.27.4,3.39.21,1.06,1.01,1.69,2.29,1.83,1.3.14,2.34-.29,2.91-1.37.52-.98.88-2.01,1.36-3.12h1.09c.36,3.28-2.11,6.77-5.35,7.48-4.64,1.02-9.12-1.19-9.24-5.83-.08-2.98-.07-5.97-.11-8.95-.04-3.25-.06-6.5-.13-9.74-.02-.81-.16-1.63-.34-2.43-.27-1.21-1.09-1.78-2.51-1.72-.87.04-1.74.23-2.71.37Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M190.89,181.22c-1.36-1.13.01-2.24-.15-3.34-.06-.41.22-.77-.47-.87-.34-.05-.41-.56-.48-.9-.51-2.42-1.97-4.46-2.72-6.78-.14-.44-.46-.78-.92-.95-1.16-.43-1.54-1.26-1.17-2.47.08-.25.17-.49.19-.75.07-.78-.17-1.46-.88-1.82-.64-.32-1.36-.15-1.8.36-.49.56-1.05,1.24-.45,2.09.38.53.08,1.22.43,1.78.17.27-.22.41-.45.51-.26.12-.45-.02-.52-.28-.05-.19-.02-.4-.09-.57-.18-.46.75-1.17-.21-1.36-.52-.1-.85-.65-1.43-.48-.11.03-.36-.03-.36-.04.09-.93-1.17-1.44-.76-2.46.15-.36.11-.7-.04-1.04-.24-.59-.38-1.22-.13-1.81.28-.67-.19-1.17-.22-1.76,0-.12-.11-.24-.27-.22-.2.02-.24.15-.27.33-.36,2.14-.37,4.3-.4,6.45,0,.53-.05.77-.65.72-.49-.04-.79.55-1.32.51-.1,0-.19,2.55-.1,2.64.57.52.48,1.22.4,1.85-.04.3-.49.23-.78.18-.28-.06-.37-.25-.22-.51.08-.15.15-.29.02-.49-.08.12-.21.21-.22.31-.02.43-.81.54-.51,1.02.33.54.98.61,1.56.65.39.02.79-.07,1.12-.3.23-.16.39-.24.06-.64-.88-1.04-1.05-2.37-.94-3.68.05-.68.83-.74,1.37-.91.49-.16.67.2.85.59.72,1.54,1.94,2.74,2.78,4.22,1.05,1.85.95,3.54.37,5.39-.41,1.32-.66,2.67-.48,4.05.21,1.59-.44,3.05-.63,4.58-.12.97.45,2.16,1.37,2.41.35.1.65.14.65.56,0,.59-.48.28-.73.32-1.03.14-1.69.69-1.91,1.79-.27,1.37-.5,2.76-.72,4.14-.3,1.88-.94,2.44-2.88,2.44-1.86,0-3.72,0-5.58,0-2,0-2.89-1.1-2.43-3.03,2.62-11.06,5.24-22.12,7.86-33.18.36-1.52.72-3.04,1.08-4.56.39-1.66.95-2.13,2.63-2.13,3.17,0,6.33,0,9.5,0,1.43,0,2.06.51,2.39,1.92,3.04,12.67,6.08,25.33,9.11,38,.45,1.86-.44,2.98-2.38,2.99-1.96,0-3.92,0-5.88,0-1.48,0-2.21-.66-2.45-2.1-.24-1.48-.52-2.95-.76-4.43-.11-.65-.39-1.21-.98-1.49-.51-.25-.51-.5-.33-.97.73-1.95,1.44-3.91,2.09-5.89.21-.65.45-.96,1.23-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M162.14,175.27c0,5.64,0,11.28,0,16.92,0,.87-.11,1.72-.45,2.51-.56,1.28-1.44,2.11-2.97,1.98-.39-.03-.79,0-1.19,0-2.45,0-3.64-1.1-3.89-3.59-.03-.29-.02-.59-.02-.89,0-11.31,0-22.63,0-33.94,0-.77.08-1.51.35-2.23.6-1.66,1.41-2.24,3.16-2.24.33,0,.66,0,.99,0,2.66,0,3.94,1.25,4.01,3.97.04,1.35,0,2.7,0,4.06,0,4.49,0,8.97,0,13.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M186.43,187.48c-.08-.69-.27-1.38.46-1.86.32-.21.31-.72.15-1-.82-1.49-.57-3.06-.26-4.56.43-2.12.25-4.04-.92-5.89-.56-.89-.35-1.83.45-3.08.26.53.54.99.72,1.48.53,1.4,1.12,2.77,1.8,4.1.44.86.19,1.85.52,2.76.23.64-.61.14-.84.48.19.22.51.43.38.85-.74,2.27-1.5,4.54-2.47,6.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M179.3,166.18c.64-.16,1.06.2,1.52.39.49.21.4.63.2.97-.28.46-.56.07-.77-.11-.39-.33-.74-.7-.94-1.26Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.42,215.64c2.05-2.05,4.59-3.23,6.95-3.23,4.24,0,5.91,2.88,5.91,8.93,0,6.43-1.91,8.76-6.25,8.76-2.22,0-4.38-.59-6.5-1.77.1,1.18.1,2.12.07,3.34v5.11h-2.19v-23.9h1.81l.21,2.78ZM11.59,226.9c2.36.76,4,1.25,5.94,1.25,3.23,0,4.48-1.56,4.48-6.84s-1.22-6.95-4.27-6.95c-1.95,0-3.65.94-6.15,2.88v9.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.15,214.49h-.83c-2.08,0-3.96.94-6.77,2.61v12.58h-2.22v-16.82h1.7l.24,2.78c2.57-2.01,5.07-3.23,7.44-3.23h.73l-.28,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.88,222.34c.28,4.59,1.98,5.84,5.84,5.84,1.98,0,4.2-.21,5.8-.42l.24,1.49c-1.42.56-4.45.83-6.36.83-5.63,0-7.82-2.43-7.82-8.89s2.19-8.79,7.54-8.79c4.83,0,6.98,1.77,7.02,5.25.03,3.02-1.11,4.69-3.86,4.69h-8.41ZM51.76,220.61c1.74,0,2.19-1.25,2.15-2.92-.04-2.36-1.42-3.37-4.69-3.37-3.93,0-5.28,1.53-5.35,6.29h7.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.52,229.33c-1.63.49-3.65.76-5.49.76-5.77,0-7.89-2.33-7.89-8.83s2.12-8.86,7.89-8.86c1.39,0,3.58.17,5.18.76l-.35,1.42c-1.39-.21-3.3-.28-4.48-.28-4.38,0-5.94,1.56-5.94,6.95s1.56,6.91,5.94,6.91c1.01,0,3.27-.07,4.9-.38l.24,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.98,222.34c.28,4.59,1.98,5.84,5.84,5.84,1.98,0,4.2-.21,5.8-.42l.24,1.49c-1.42.56-4.45.83-6.36.83-5.63,0-7.82-2.43-7.82-8.89s2.19-8.79,7.54-8.79c4.83,0,6.98,1.77,7.02,5.25.03,3.02-1.11,4.69-3.86,4.69h-8.41ZM86.86,220.61c1.74,0,2.19-1.25,2.15-2.92-.04-2.36-1.42-3.37-4.69-3.37-3.93,0-5.28,1.53-5.35,6.29h7.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.03,227.07c-2.01,1.77-4.24,3.02-6.74,3.02-4.34,0-6.01-2.81-6.01-8.86,0-6.5,1.95-8.83,6.29-8.83,2.15,0,4.27.56,6.36,1.63-.14-1.15-.14-2.08-.14-3.3v-5.39h2.19v24.32h-1.7l-.24-2.61ZM107.78,215.57c-2.26-.76-3.86-1.22-5.77-1.22-3.23,0-4.45,1.56-4.45,6.84s1.22,6.95,4.34,6.95c1.98,0,3.4-.8,5.87-2.68v-9.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.31,222.34c.28,4.59,1.98,5.84,5.84,5.84,1.98,0,4.2-.21,5.8-.42l.24,1.49c-1.42.56-4.45.83-6.36.83-5.63,0-7.82-2.43-7.82-8.89s2.19-8.79,7.54-8.79c4.83,0,6.98,1.77,7.02,5.25.03,3.02-1.11,4.69-3.86,4.69h-8.41ZM125.19,220.61c1.74,0,2.19-1.25,2.15-2.92-.04-2.36-1.42-3.37-4.69-3.37-3.93,0-5.28,1.53-5.35,6.29h7.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.42,215.64c2.68-2.05,5.21-3.23,7.78-3.23,2.95,0,4.52,1.6,4.52,4.62v12.65h-2.19v-12.06c0-2.4-.87-3.3-2.92-3.3-2.19,0-4.13,1.04-6.98,2.92v12.44h-2.22v-16.82h1.84l.17,2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.28,229.61c-1.04.21-2.78.35-3.51.35-2.78,0-4.17-1.49-4.17-4.2v-11.15h-3.06v-1.56l3.06-.17v-5.11h2.19v5.11h5.7v1.74h-5.7v10.91c0,1.7.8,2.43,2.47,2.43h2.75l.28,1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.74,222.34c.28,4.59,1.98,5.84,5.84,5.84,1.98,0,4.2-.21,5.8-.42l.24,1.49c-1.42.56-4.45.83-6.36.83-5.63,0-7.82-2.43-7.82-8.89s2.19-8.79,7.54-8.79c4.83,0,6.98,1.77,7.02,5.25.03,3.02-1.11,4.69-3.86,4.69h-8.41ZM176.63,220.61c1.74,0,2.19-1.25,2.15-2.92-.04-2.36-1.42-3.37-4.69-3.37-3.93,0-5.28,1.53-5.35,6.29h7.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.55,221.58c-2.57-.52-3.75-1.77-3.75-4.59,0-4.03,2.05-4.62,6.46-4.59,2.12.03,4.79.21,6.88.52l-.21,1.6c-2.08-.1-4.31-.21-6.39-.21-3.33-.03-4.59.04-4.59,2.68,0,2.02.9,2.47,2.57,2.81l5.18.97c2.61.52,3.89,1.7,3.89,4.52,0,4.17-2.33,4.76-6.98,4.76-1.39,0-3.68-.03-6.43-.45l.17-1.63c1.84.17,3.68.24,5.87.21,3.93-.03,5.21-.42,5.21-2.88,0-1.98-1.11-2.43-2.75-2.75l-5.14-.97Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M390.92,333.66c-1.8,0-3.5-.3-5-.9s-2.9-1.5-4-2.5c-1.1-1.1-2-2.4-2.6-3.8-.6-1.5-.9-3.1-.9-4.8s.3-3.3.9-4.8,1.5-2.7,2.6-3.8c1.1-1.1,2.5-1.9,4-2.5s3.2-.9,5-.9,3.5.3,5,.9c1.6.6,2.9,1.5,4,2.5,1.1,1.1,2,2.3,2.7,3.8.6,1.5,1,3.1,1,4.8s-.3,3.4-1,4.8-1.5,2.8-2.7,3.8c-1.1,1.1-2.5,1.9-4,2.5-1.6.6-3.2.9-5,.9ZM390.92,331.96c1.5,0,2.9-.3,4.3-.8,1.3-.5,2.5-1.2,3.4-2.1,1-.9,1.7-2,2.3-3.3.6-1.3.8-2.7.8-4.2s-.3-2.8-.8-4.1c-.5-1.3-1.3-2.4-2.3-3.3s-2.1-1.7-3.4-2.2-2.8-.8-4.3-.8-3,.3-4.3.8-2.4,1.3-3.4,2.2c-1,.9-1.7,2-2.2,3.3s-.8,2.6-.8,4.1.3,2.8.8,4.1c.5,1.3,1.3,2.4,2.2,3.3.9,1,2.1,1.7,3.4,2.2s2.7.8,4.3.8ZM385.52,314.06h6.5c.7,0,1.3.1,1.9.4s1.1.7,1.5,1.1c.4.5.7,1,1,1.6s.4,1.2.4,1.8c0,.9-.2,1.8-.7,2.6-.5.8-1.1,1.4-1.9,1.7l3.5,5.6h-3.6l-3.1-5h-2.1v5h-3.2v-14.7l-.2-.1ZM391.82,321.16c.6,0,1-.2,1.3-.6s.5-.9.5-1.6-.2-1.2-.6-1.6c-.4-.3-.8-.5-1.3-.5h-3v4.2h3.1v.1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIusPrecAsset);
export default __webpack_public_path__ + "static/media/ius-prec-Asset.158ff6c1068d329f565483b109024aca.svg";
export { ForwardRef as ReactComponent };